export function setSearchLimitsLoading (state, loading = false) {
  state.searchlimitsLoading = loading
}

export function setTodayLimitsLoading (state, loading = false) {
  state.todaylimitsLoading = loading
}

export function setSearchLimits (state, searchlimits) {
  state.searchlimits = searchlimits.data
  state.searchlimitsCurrentPage = searchlimits.current_page
  state.searchlimitsLastPage = searchlimits.last_page
  state.searchlimitsPerPage = searchlimits.per_page
  state.searchlimitsTotal = searchlimits.total
}

export function setTodayLimits (state, limits) {
  for (var key in state.searchlimits) {
    state.searchlimits[key].limit_today = limits[key]
  }
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
